

import Vue from 'vue'
import Component from "vue-class-component";
import {namespace} from "vuex-class";
import {BoListPanel} from "bonomo/dist";
import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";
import {Prop} from "vue-property-decorator";
import {PermissionHelper} from "@/helpers/PermissionHelper";
import {EUserPermissions} from "@/model/EUserPermissions";
import {IAuthUserData} from "@/store/modules/authModule";
import {IListSshConnection} from "@/model/SshConnections/sshConnectionInterfaces";

const sshConnectionModule = namespace("sshConnectionModule");
const authModule = namespace("authModule");

@Component({
  components: {
    BoListPanel,
  }
})

export default class SshConnectionsList extends Vue {
  @Prop({default: 0})
  private lockerId!: number;

  @sshConnectionModule.Getter('sshConnectionsList')
  private sshconnections!: IListSshConnection[];

  @authModule.Getter('userData')
  authUser!: IAuthUserData;

  @sshConnectionModule.Action('fetchSshConnections')
  protected fetchSshConnectionsAction!: (filters: any) => Promise<any>;

  submitting: boolean = false;

  protected get headers(): BetterDataTableHeader[] {
    return [
      { text: this.$t('common.id'), align: 'start', sortable: false, value: 'id' },
      { text: this.$t('sshconnections.list.deviceId'), align: 'center', sortable: false, value: 'device_id' },
      { text: this.$t('sshconnections.list.vps_ip'), align: 'end', sortable: false, value: 'vps_ip' },
      { text: this.$t('sshconnections.list.vps_port'), align: 'end', sortable: false, value: 'vps_port' },
      { text: this.$t('sshconnections.list.tunnel_port'), align: 'end', sortable: false, value: 'tunnel_port' },
      { text: this.$t('sshconnections.list.connectionstring'), align: 'start', sortable: false, value: 'connectionstring' },
    ];
  }

  protected loading: boolean = false;

  protected get canRemotelyConnect() {
    const authUser = this.authUser;
    return PermissionHelper.hasPermission(authUser, EUserPermissions.PERMISSION_DEVELOPER, this.lockerId);
  }

  private fetchSshConnections(filters: any) {
    this.fetchSshConnectionsAction({ filters});
  }

  onCopyLink(port: string, sshUser: string) {
    navigator.clipboard.writeText('ssh -p ' + port + ' ' + sshUser + '@localhost');
  }

}
